import { API_ROOT_URL } from '@/lib/constants/api';
import { apiFetch } from '@/lib/utils/apiFetch';
import type {
  AdminFiberCocModel,
  AdminFiberCocModelsResponse,
  PatchAdminFiberCocModelBody,
} from './types';

/**
 * Global fiber chain-of-custody models, served under
 * `/api/admin/fiber/coc-models` on `API_ROOT_URL`.
 */

/** The list. Takes a pre-built query string; paging, sort and filter live in the hook. */
export async function fetchAdminFiberCocModels(
  qs: string,
): Promise<AdminFiberCocModelsResponse> {
  return apiFetch<AdminFiberCocModelsResponse>(
    `/api/admin/fiber/coc-models?${qs}`,
    undefined,
    API_ROOT_URL,
  );
}

/**
 * Replaces the model's materials and/or facility processes. Answers the
 * updated model in the `{ data, metadata }` envelope.
 */
export async function patchAdminFiberCocModel(
  id: string,
  body: PatchAdminFiberCocModelBody,
): Promise<{ data: AdminFiberCocModel }> {
  return apiFetch<{ data: AdminFiberCocModel }>(
    `/api/admin/fiber/coc-models/${encodeURIComponent(id)}`,
    { method: 'PATCH', body: JSON.stringify(body) },
    API_ROOT_URL,
  );
}
